import { render, staticRenderFns } from "./SelectMessageTemplate.vue?vue&type=template&id=3b3926cd&scoped=true&"
import script from "./SelectMessageTemplate.vue?vue&type=script&lang=ts&"
export * from "./SelectMessageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMessageTemplate.vue?vue&type=style&index=0&id=3b3926cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3926cd",
  null
  
)

export default component.exports